// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
exports.push([module.id, ".slot.empty[data-v-4cca831c]{border:2px dashed rgba(0,0,0,.15)!important;color:rgba(0,0,0,.4)}.rank-ind[data-v-4cca831c]{display:flex;flex-shrink:0;align-items:center;justify-content:center;width:36px!important;height:36px!important;padding:0!important;font-weight:700}", ""]);
// Exports
module.exports = exports;
